// eslint-disable-next-line import/prefer-default-export
export const adapterChannelGroupIndexTypes = {
  INTERNAL: 0,
  PORT1: 1,
  PORT2: 2,
  SWITCH: 4,
  // RSSI: 4,
};
